// User roles and permissions
export const ROLES = {
  VISITOR: 'visitor',
  OWNER: 'owner',
  SUPERADMIN: 'superadmin',
  // Alias for backward compatibility
  ADMIN: 'superadmin'
};

export const PERMISSIONS = {
  [ROLES.VISITOR]: [
    'view_portfolio',
    'view_projects',
    'view_insights',
    'view_visualizations'
  ],
  [ROLES.OWNER]: [
    // All visitor permissions
    'view_portfolio',
    'view_projects',
    'view_insights',
    'view_visualizations',
    // Owner-specific: manage own portfolio
    'manage_own_portfolio',
    'auto_import_repos',
    'view_github_orgs',
    'lateral_thinking_analysis',
    'manage_collections',
    'export_data',
    'view_owner_dashboard'
  ],
  [ROLES.SUPERADMIN]: [
    // All permissions
    'view_portfolio',
    'view_projects',
    'view_insights',
    'view_visualizations',
    'manage_own_portfolio',
    'auto_import_repos',
    'view_github_orgs',
    'lateral_thinking_analysis',
    'manage_collections',
    'export_data',
    'view_owner_dashboard',
    // Superadmin-specific: system administration
    'manage_users',
    'manage_all_portfolios',
    'configure_system',
    'view_all_analytics',
    'manage_tenants',
    'view_admin_dashboard'
  ]
};

/**
 * Securely determine user role using Firebase Custom Claims ONLY.
 */
export const determineUserRole = async (firebaseUser) => {
  try {
    const tokenResult = await firebaseUser.getIdTokenResult(true);
    const claims = tokenResult.claims;

    if (claims.role === 'superadmin' || claims.role === 'admin') {
      return ROLES.SUPERADMIN;
    }
    if (claims.role === 'owner') {
      return ROLES.OWNER;
    }
    return ROLES.VISITOR;
  } catch (error) {
    console.error('Error determining user role:', error);
    return ROLES.VISITOR;
  }
};

/**
 * Get additional user claims
 */
export const getUserClaims = async (firebaseUser) => {
  try {
    const tokenResult = await firebaseUser.getIdTokenResult(true);
    return {
      role: tokenResult.claims.role,
      githubUsername: tokenResult.claims.githubUsername,
      canManageOrgs: tokenResult.claims.canManageOrgs || [],
    };
  } catch (error) {
    console.error('Error getting user claims:', error);
    return { role: 'visitor' };
  }
};
